import { get_user_details } from "@/router";
import DisscussionComment from '@/components/DisscussionComment/DiscussionComment.vue';
import Sidebar from '@/components/Sidebar/SidebarView.vue';
import Navbar from '@/components/HomeNavBar/HomeNavBar.vue';
import InactivityModal from '@/components/InactivityTracker/InactivityTracker.vue';
import discussionMethods from './create_discussion_methods';

export default {
  components: {
    DisscussionComment,
    Sidebar,
    Navbar,
    InactivityModal,
  },
  data() {
    return ({
      topic_name: '',
      description: '',
      disscussion_topics: [],
      discussion_dashboard: {},
      comment_modal_visible: false,
      report_data: null,
      editTopicData: {
        topic_id: null,
        title: '',
        description: ''
      },
      user_details: {},
      errors: {},
      selected_category: null,
      showDiscussionForm: false,
      showEditTopicForm: false,
      maxLength : 150,
      expandedTopics: [],
      isLoading: true,
    })
  },
  computed: {
    discussion_dashboard_cards() {
      return [
        { label: 'Total Discussions', value: this.get_discussion_dashboard_value('total_count', this.disscussion_topics.length), icon: 'bi-chat-left-text-fill', tone: 'primary' },
        { label: 'Portal', value: this.get_discussion_dashboard_value('portal_count'), icon: 'bi-grid-3x3-gap-fill', tone: 'info' },
        { label: 'Home', value: this.get_discussion_dashboard_value('home_count'), icon: 'bi-house-fill', tone: 'success' },
        { label: 'Groups', value: this.get_discussion_dashboard_value('group_count'), icon: 'bi-people-fill', tone: 'warning' },
        { label: 'Organization', value: this.get_discussion_dashboard_value('organization_count'), icon: 'bi-building-fill', tone: 'secondary' },
        { label: 'Comments', value: this.get_discussion_dashboard_value('total_comments', this.local_comment_count), icon: 'bi-chat-square-text-fill', tone: 'success' },
      ];
    },
    local_comment_count() {
      return (this.disscussion_topics || [])
        .reduce((total, topic) => total + this.get_topic_comment_count(topic), 0);
    },
  },
  mounted() {
    this.user_details = get_user_details();
    const group_id = this.$route?.params?.group_id;
    if (group_id) {
      this.filter_group_discussions(group_id);
    }else {
      this.fetch_discussion_topics();
    }

  },
  methods: discussionMethods,
}

